import { useEffect, useRef, useState } from "react"

export type UseIntersectionObserverOptions = {
  readonly threshold?: number | Array<number>
  readonly root?: Element | null
  readonly rootMargin?: string
}

export function useIntersectionObserver<T extends HTMLElement>({
  threshold = 0,
  root = null,
  rootMargin = "0px",
}: UseIntersectionObserverOptions = {}) {
  const [isIntersecting, setIsIntersecting] = useState(false)
  const elementRef = useRef<T | null>(null)

  useEffect(() => {
    const element = elementRef.current

    if (!element) {
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsIntersecting(entry.isIntersecting)
      },
      { root, rootMargin, threshold },
    )

    observer.observe(element)

    return () => {
      observer.disconnect()
    }
  }, [threshold, root, rootMargin])

  return { elementRef, isIntersecting } as const
}
